// Date-range presets. Quarters and years follow the pharmacy's year start month (1 = Jan, 4 = April).
const iso = (d) => d.toLocaleDateString("en-CA");
const day = (y, m, d) => new Date(y, m, d); // m is 0-based
const addDays = (d, n) => day(d.getFullYear(), d.getMonth(), d.getDate() + n);
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function yearStart(now, ys) {
  const m0 = ys - 1;
  const y = now.getMonth() >= m0 ? now.getFullYear() : now.getFullYear() - 1;
  return day(y, m0, 1);
}

function quarterStart(now, ys) {
  const start = yearStart(now, ys);
  const months = (now.getFullYear() - start.getFullYear()) * 12 + now.getMonth() - start.getMonth();
  return day(start.getFullYear(), start.getMonth() + Math.floor(months / 3) * 3, 1);
}

const endOfMonths = (start, n) => day(start.getFullYear(), start.getMonth() + n, 0);

export function presets(ys = 4, now = new Date()) {
  const t = day(now.getFullYear(), now.getMonth(), now.getDate());
  const wk = addDays(t, -((t.getDay() + 6) % 7));
  const mo = day(t.getFullYear(), t.getMonth(), 1);
  const q = quarterStart(t, ys);
  const y = yearStart(t, ys);
  const fy = ys !== 1;
  const yLabel = (s) => (fy ? `${MON[s.getMonth()]} ${s.getFullYear()} – ${MON[(s.getMonth() + 11) % 12]} ${s.getFullYear() + 1}` : `${s.getFullYear()}`);
  const r = (key, label, from, to, group) => ({ key, label, from: from && iso(from), to: to && iso(to), group });
  const lastQ = day(q.getFullYear(), q.getMonth() - 3, 1);
  const lastY = day(y.getFullYear() - 1, y.getMonth(), 1);
  return [
    r("today", "Today", t, t, "Days"),
    r("yesterday", "Yesterday", addDays(t, -1), addDays(t, -1), "Days"),
    r("last_7", "Last 7 days", addDays(t, -6), t, "Days"),
    r("last_30", "Last 30 days", addDays(t, -29), t, "Days"),
    r("last_90", "Last 90 days", addDays(t, -89), t, "Days"),
    r("this_week", "This week", wk, t, "Weeks & months"),
    r("last_week", "Last week", addDays(wk, -7), addDays(wk, -1), "Weeks & months"),
    r("this_month", "This month", mo, t, "Weeks & months"),
    r("last_month", "Last month", day(mo.getFullYear(), mo.getMonth() - 1, 1), addDays(mo, -1), "Weeks & months"),
    r("last_12_months", "Last 12 months", day(t.getFullYear() - 1, t.getMonth(), t.getDate() + 1), t, "Weeks & months"),
    r("this_quarter", `This quarter (${MON[q.getMonth()]}–${MON[(q.getMonth() + 2) % 12]})`, q, t, fy ? "Financial year" : "Quarters & years"),
    r("last_quarter", `Last quarter (${MON[lastQ.getMonth()]}–${MON[(lastQ.getMonth() + 2) % 12]})`, lastQ, endOfMonths(lastQ, 3), fy ? "Financial year" : "Quarters & years"),
    r("this_year", `${fy ? "This financial year" : "This year"} (${yLabel(y)})`, y, t, fy ? "Financial year" : "Quarters & years"),
    r("last_year", `${fy ? "Last financial year" : "Last year"} (${yLabel(lastY)})`, lastY, endOfMonths(lastY, 12), fy ? "Financial year" : "Quarters & years"),
    r("calendar_year", `Calendar year ${t.getFullYear()}`, day(t.getFullYear(), 0, 1), t, fy ? "Financial year" : "Quarters & years"),
    r("all", "All time", null, null, "Other"),
  ].filter((p) => fy || p.key !== "calendar_year");
}

export const preset = (key, ys) => presets(ys).find((p) => p.key === key);

export const fmtDay = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export const rangeLabel = (v) => {
  if (!v.from && !v.to) return "All time";
  if (v.from === v.to) return fmtDay(v.from);
  return `${v.from ? fmtDay(v.from) : "Start"} – ${v.to ? fmtDay(v.to) : "today"}`;
};

export const rangeQuery = (v) => new URLSearchParams(Object.entries({ date_from: v.from, date_to: v.to }).filter(([, x]) => x)).toString();

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
